























import {
  BaseStandardModal,
  BasePrimaryButton
} from "@web-components";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

export default {
  components: {
    BaseStandardModal,
    BasePrimaryButton
  },
  props: {
    portal: {
      type: String,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const dictionary = useDictionary();
    return {
      ...dictionary
    };
  }
};
